<div class="modal-header">
    <h4 class="modal-title">{{'SalesSearch.Errors.ErrorModalTitle' | translate}}</h4>
</div>
<div class="modal-body">
    {{errorLabel | translate}}
</div>
<div class="modal-footer">
    <button class="btn btn-primary" type="button" (click)="ok()">{{ 'Shared.Confirmation.OK' | translate }}</button>
</div>